<template lang="">
  <div class="w-full">
    <div class="relative my-12 mx-12 shadow-md sm:rounded-lg content-center">
      <vue-good-table
        oncontextmenu="return false;"
        :columns="columns"
        :rows="rows"
        @on-row-click="closeMenu"
        @on-row-dblclick="onRowClick"
        :search-options="{
          enabled: true,
          externalQuery: searchQuery,
          //    externalQuery: searchTerm
        }"
        :pagination-options="{
          mode: 'pages',
          perPage: 10,
          perPageDropdown: [10, 20, 30, 40, 50],
          enabled: true,
        }"
        compactMode
      >
        <template slot="table-row" slot-scope="props" >
          <div
            @contextmenu="openMenu($event, props.row)"
            @dblclick="onRowDoubleClick(props.row)"
            style="font-weight: bold"
            :style="{'color': props.column.field == 'color'?props.row.color:'black' }"
            class="flex flex-row justify-center align-center"
          >
            {{ props.formattedRow[props.column.field] }}
          </div>
          
          <!-- Color for fields page -->
          <span
          v-if="props.column.field == 'color' && name == 'projectfields'"
          class="flex flex-row justify-center align-center"
          >
          <div
              v-bind:style="{ width: '10%', height:'17px', 'background-color': props.row.color}"
            >
          </div>
          </span>
          <!-- Actions for projects page -->
          <span
            v-if="props.column.field == 'actions' && name == 'project'"
            class=""
          >
            <button
              v-if="$store.state.permissions.viewBatches"
              class="text-white bg-woo hover:translate-x-0 hover:bg-hoverwoo px-4"
              @click="method1(props.row.id)"
            >
              Batches
            </button>
          </span>

          <!-- Actions for batches page -->
          <span
            v-else-if="props.column.field == 'actions' && name == 'batch'"
          >
            <button
              v-if="props.row.numberOfImages>0"
              class="text-white bg-woo hover:translate-x-0 hover:bg-hoverwoo px-4"
              @click="$router.push(`../batches/${props.row.id}/images`)"
            >
              Images
            </button>
            <button
              v-else-if="$store.state.permissions.addImages"
              class="text-white bg-woo hover:translate-x-0 hover:bg-hoverwoo px-2 py-1"
              style="font-size:small"
              @click="openMenu($event, props.row); uploadImageModal = true"
            >
              Add Images
            </button>
          </span>

          <span
            v-else-if="
              props.column.field == 'viewInformation' && name == 'whizz'
            "
            class=""
          >
            <button
              class="text-white bg-woo hover:translate-x-0 hover:bg-hoverwoo px-4"
              @click="viewMore(props.row.furtherInformation)"
            >
              View
            </button>
          </span>

          <span
            v-else-if="
              props.column.field == 'actions' &&
              name == 'users' &&
              $store.state.permissions.editUsers == true
            "
            class=""
          >
            <button
              class="text-white bg-woo hover:translate-x-0 hover:bg-hoverwoo px-4"
              @click="$emit('editUser', props.row)"
            >
              Edit
            </button>
          </span>
          <!-- Actions for projects users page -->
          <span
            v-if="props.column.field == 'actions' && name == 'projectusers'"
          >
            <button
              class="text-white bg-woo hover:translate-x-0 p-2 hover:bg-hoverwoo"
              v-on:click="$emit('removeUser', props.row.id)"
            >
              Remove
            </button>
          </span>
          <!-- Actions for projects fields page -->
          <span
            v-if="props.column.field == 'actions' && name == 'projectfields' && props.row.name!=null &&  $store.state.permissions.editFields == true"
          >
            <button
              class="text-white bg-woo hover:translate-x-0 p-2 hover:bg-hoverwoo"
              @click="editFieldModal.displayEditFieldModal= true; editFieldModal.row={...props.row}"
            >
              Edit
            </button>
          </span>
          <!-- Actions for Others -->
          <!-- <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span> -->
        </template>
      </vue-good-table>
      <ul
        @click="viewMenu = false"
        id="right-click-menu"
        tabindex="-1"
        @blur="closeMenu"
        v-if="viewMenu && name == 'project'"
        :style="{ top: top, left: left }"
      >
        <li>
          <button
            v-if="$store.state.permissions.viewBatches"
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
            @click="method1(selectedProjectId)"
          >
            Batches
          </button>
        </li>
        <li>
          <button
            v-if="$store.state.permissions.addBatch"
            @click="displayAddBatch = true"
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
          >
            Add Batch
          </button>
        </li>
        <li>
          <button
            v-if="$store.state.permissions.deleteProjects"
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
            @click="deleteProject = true"
          >
            Toggle
          </button>
        </li>
        <li>
          <button
            v-if="$store.state.permissions.addPermissions"
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
            @click="$router.push(`../projects/${selectedProjectId}/users`)"
          >
            Users
          </button>
        </li>
        <li>
          <button
          v-if="$store.state.permissions.addPermissions"
          class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="$router.push(`../projects/${selectedProjectId}/fields`)"
        >
          Fields
        </button>
        </li>
      </ul>

      <ul
        @click="viewMenu = false"
        id="right-click-menu"
        tabindex="-1"
        @blur="closeMenu"
        v-if="viewMenu && name == 'batch'"
        :style="{ top: top, left: left }"
      >
        <li>
          <button
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
            @click="$router.push(`../batches/${selectedProjectId}/images`)"
          >
            Images
          </button>
        </li>

        <li>
          <button
            v-if="$store.state.permissions.import"
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
            @click="$emit('openBatch', selectedProjectId, 'import')"
          >
            Import
          </button>
        </li>

        <li>
          <button
            v-if="$store.state.permissions.export"
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
            @click="$emit('openBatch', selectedProjectId, 'export')"
          >
            Export
          </button>
        </li>

        <li>
          <button
            v-if="$store.state.permissions.addImages"
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
            @click="uploadImageModal = true"
          >
            Add Images
          </button>
        </li>

        <li>
          <button
            v-if="$store.state.permissions.addPermissions"
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
            @click="$router.push(`../batches/${selectedProjectId}/users`)"
          >
            Users
          </button>
        </li>

        <li>
          <button
            v-if="$store.state.permissions.deleteBatches"
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
            @click="deleteProject = true"
          >
            Toggle
          </button>
        </li>
        <li>
          <button
            v-if="$store.state.permissions.downloadImage"
            class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
            role="menuitem"
            @click="downloadAllFiles()"
          >
            Download
          </button>
        </li>
      </ul>
      <GiveAccessModal
        v-if="displayUserModal"
        :projectId="selectedProjectId"
        @close="displayUserModal = false"
      />

      <ConfirmationModalVue
        v-if="deleteProject"
        :id="selectedProjectId"
        :onConfirm="method2"
        :title="'Confirm'"
        :message="'Are you sure you want to toggle this ' + name"
        :onDecline="closeModal"
      />
      <AddBatchModal
        v-if="displayAddBatch"
        :receivedProjectId="selectedProjectId"
        @addBatch="addBatch"
        @close="displayAddBatch = false"
      />
      <UploadImageModal
        v-if="uploadImageModal"
        :row="row"
        :imageTypes="null"
        @close="uploadImageModal = false"
        @uploadImage="uploadImage()"
      />

      <ViewTextModal
        v-if="viewTextModal"
        :text="this.furtherInformation"
        @close="viewTextModal = false"
      />
      <EditAddFieldModal
        v-if="editFieldModal.displayEditFieldModal"
        :row="editFieldModal.row"
        :type="editFieldModal.type"
        @editField="method1"
        @close="editFieldModal.displayEditFieldModal = false"
      />
      <!--  -->
      <div
        v-if="name == 'batch'"
        id="batchesMenu"
        class="py-1 rounded-md shadow-xs hidden bg-gray-300 z-1"
      >
        <button
          class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="$router.push(`../batches/${selectedProjectId}/images`)"
        >
          Images
        </button>
        <button
          v-if="$store.state.permissions.import"
          class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="$emit('openBatch', selectedProjectId, 'import')"
        >
          Import
        </button>
        <button
          v-if="$store.state.permissions.export"
          class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="$emit('openBatch', selectedProjectId, 'export')"
        >
          Export
        </button>
        <button
          v-if="$store.state.permissions.addImages"
          class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="uploadImageModal = true"
        >
          Add Images
        </button>
        <button
          v-if="$store.state.permissions.addPermissions"
          class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="$router.push(`../batches/${selectedProjectId}/users`)"
        >
          Users
        </button>
        <button
          v-if="$store.state.permissions.deleteBatches"
          class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="deleteProject = true"
        >
          Toggle
        </button>
      </div>
      <!--  -->

      <div
        v-if="name == 'project'"
        id="projectsMenu"
        class="py-1 rounded-md shadow-xs hidden bg-gray-300 z-1"
      >
        <button
          v-if="$store.state.permissions.viewBatches"
          class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="method1(selectedProjectId)"
        >
          Batches
        </button>
        <button
          v-if="$store.state.permissions.addBatch"
          @click="displayAddBatch = true"
          class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
        >
          Add Batch
        </button>
        <button
          v-if="$store.state.permissions.deleteProjects"
          class="block w-full py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="deleteProject = true"
        >
          Toggle
        </button>

        <button
          v-if="$store.state.permissions.addPermissions"
          class="block w-full text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="$router.push(`../projects/${selectedProjectId}/users`)"
        >
          Users
        </button>
        <button
          v-if="$store.state.permissions.addPermissions"
          class="block w-full text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
          role="menuitem"
          @click="$router.push(`../projects/${selectedProjectId}/fields`)"
        >
          Fields
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Http, { OCR_ENDPOINTS } from "../request";
import ConfirmationModalVue from "../components/ConfirmationModal.vue";
import "vue-good-table/dist/vue-good-table.css";
import GiveAccessModal from "../components/GiveAccessModal.vue";
import ViewTextModal from "../components/ViewTextModal.vue";
import AddBatchModal from "./AddBatchModal.vue";
import { VueGoodTable } from "vue-good-table";
import VueTailwind from "vue-tailwind";
import "vue-toastification/dist/index.css";
import UploadImageModal from "./UploadImageModal.vue";
import { Modal } from "../helpers/Modal";
import EditAddFieldModal from "../components/editAddFieldModal.vue";
Vue.use(VueTailwind);

export default {
  created() {
    document.addEventListener("click", this.closeMenu());
  },

  components: {
    ConfirmationModalVue,
    VueGoodTable,
    GiveAccessModal,
    AddBatchModal,
    UploadImageModal,
    ViewTextModal,
    EditAddFieldModal
  },

  data() {
    return {
      // Menu
      viewMenu: false,
      top: "0px",
      left: "0px",
      // ***** //
      selectedRow: null,
      uploadImageModal: false,
      viewTextModal: false,
      displayAddBatch: false,
      newProjects: null,
      deleteProject: false,
      displayUserModal: false,
      selectedProjectId: null,
      searchQuery: null,
      furtherInformation: null,
      file: null,
      batchId: null,
      editFieldModal:{ displayEditFieldModal: false, row:{}, type:{ name: 'Edit', method: 'editField'} },
    };
  },
  props: {
    name: String,
    columns: Array,
    rows: Array,
    method1: { type: Function },
    method2: { type: Function },
    method3: { type: Function },
  },

  methods: {
    handler(e) {},
    setMenu(top, left) {
      this.top = top - 180 + "px";
      this.left = left - 180 + "px";
    },

    closeMenu() {
      this.selectedProjectId = null;
      this.viewMenu = false;
    },

    openMenu(e, row) {
      this.selectedProjectId = row.id;
      this.row= row;
      this.viewMenu = true;

      Vue.nextTick(() => {
        //    this.$el.right.focus();

        this.setMenu(e.y, e.x);
      });
      e.preventDefault();
    },

    // onRowDoubleClick(e, id) {
    //   if (this.name == "project") {
    //     var d = document.getElementById("projectsMenu");
    //     this.selectedProjectId = id;

    //     //   this.selectedRow = e.pageIndex;
    //     //   const tbody = document.getElementsByTagName("tbody")[0];
    //     //   this.selectedRow = tbody.childNodes[this.selectedRow + 2];
    //     //   this.selectedRow.style.background = "#F2F4F7";
    //     d.style.position = "absolute";
    //     d.style.display = "block";
    //     d.style.left = e.x - 80 + "px";
    //     d.style.top = e.y - 170 + "px";
    //   }
    //   if (this.name == "batch") {
    //     var d = document.getElementById("batchesMenu");
    //     this.selectedProjectId = id;

    //     //   this.selectedRow = e.pageIndex;
    //     //   const tbody = document.getElementsByTagName("tbody")[0];
    //     //   this.selectedRow = tbody.childNodes[this.selectedRow + 2];
    //     //   this.selectedRow.style.background = "#F2F4F7";
    //     d.style.position = "absolute";
    //     d.style.display = "block";
    //     d.style.left = e.x - 80 + "px";
    //     d.style.top = e.y - 170 + "px";
    //   }
    // },
    onRowClick() {
      // if (this.selectedRow) {
      //   this.selectedRow.style.removeProperty("background");
      // }
      var d = document.getElementById("projectsMenu");
      if (d) d.style.display = "none";
      var a = document.getElementById("batchesMenu");
      if (a) a.style.display = "none";
    },

    addBatch(name, id) {
      Http()
        .post(OCR_ENDPOINTS.projects + `/${id}/batches`, { batchName: name })
        .then((response) => {
          this.$toast.success("Batch added succesfully");
          this.displayAddBatch = false;
        })
        .catch((error) => {
          this.$toast.error(error.response.data);
        })
        .finally(() => {});
    },

    closeModal() {
      this.deleteProject = false;
      this.selectedProjectId = null;
    },

    viewMore(text) {
      this.furtherInformation = text;
      this.viewTextModal = true;
    },

    async downloadAllFiles() {
      var batch = this.rows.find(
        (element) => element.id == this.selectedProjectId
      );
   
      Modal.showConfirmationModal({
        message:
          "Are You Sure You Would Like to Download Zip files in Downloads?",
        title: "Confirm ",
      }).then((confirmed) => {
        if (confirmed) {
          this.$toast.success("Download Started");
          this.getImagesToDownload( batch.name + ".zip",batch);
   
          
        }
      });
    },
    downloadingZipFile(blob, filename) {
      var a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob);
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    getImagesToDownload( filename, batch) {
      Http()
        .get(
          OCR_ENDPOINTS.batches +
            `${this.selectedProjectId}` +
            "/images/download",
          {
            responseType: "blob",
            params: {
              size: 999999,
              page: 0,
            },
            onDownloadProgress: progressEvent => {
              progressEvent.numOfImages=batch.numberOfImages;
              console.log('dispatch:',progressEvent);
              this.$store.dispatch('loader/handleProgress', progressEvent);
          },
          showLoader:true,
          }
        )
        .then((response) => {
          this.downloadingZipFile(response.data, filename);
        })
        .catch((error) => {
          // this.validProject = false;
        })
        .finally(() => {
         this.$store.dispatch('loader/handleProgress', {});
        });
    },
  },
};
</script>
<style>
/* Actions Menu */

#right-click-menu {
  background: #f3f4f7;
  border-radius: 10px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 250px;
  z-index: 999999;
}

#right-click-menu li {
  border-bottom: 1px solid #e0e0e0;
  margin: 0;
}

#right-click-menu li:last-child {
  border-bottom: none;
}

#right-click-menu li:hover {
  color: red;
}
/* *** */

.left-0 {
  right: 0 !important;
}
button {
  border-radius: 0.25rem;
}
.sortable:hover {
  color: black !important;
}

button:hover {
  background-color: #f3f4f7 !important;
  color: black !important;
}

/* x-axis scroll */
.vgt-responsive {
  overflow-x: hidden;
}

.vgt-table td {
  text-align: center !important;
}
.vgt-table th {
  text-align: center !important;
}
.vue-js-switch .v-switch-label.v-right[data-v-25adc6c0] {
  right: 5px !important;
}
.vgt-table th.sortable button:hover{
  color:black !important;
}
.vgt-table thead th:hover {
    color: #606266 !important;
}
</style>
